/**
 * Configuration data for the app, as in Config.cs.
 */

// let WebApiBaseUrl: string = "http://localhost:5000"; //Local
// let WebApiBaseUrl: string = "http://www.dev.kapacitetsoverblik.dk/api"; //Dev
//let WebApiBaseUrl: string = "https://kapacitetsoverblik.rehfeld.dk/api"; //Prod
let WebApiBaseUrl: string =
  "https://kapacitetsoverblik-prod.solutions.iqvia.com/api"; //Prod
// let WebApiBaseUrl: string = "https://kapacitetsoverblik-test.solutions.iqvia.com/api"; //Test

export class Config {
  // public static readonly BaseUrl: string = "http://localhost:5000"; //Local
  //public static readonly BaseUrl: string = "http://www.dev.kapacitetsoverblik.dk/api"; //Local
  //public static readonly BaseUrl: string =  "https://kapacitetsoverblik.rehfeld.dk/api"; // Prod
  public static readonly BaseUrl: string =
    "https://kapacitetsoverblik-prod.solutions.iqvia.com/api"; // Prod
  // public static readonly BaseUrl: string = "https://kapacitetsoverblik-test.solutions.iqvia.com/api"; // Test

  /**
   * @see https://identityserver4.readthedocs.io/en/dev/endpoints/token.html
   */
  public static readonly TOKEN_ENDPOINT: string =
    WebApiBaseUrl + "/connect/token";

  public static readonly REVOCATION_ENDPOINT: string =
    WebApiBaseUrl + "/connect/revocation";

  /**
   * @see https://identityserver4.readthedocs.io/en/dev/endpoints/userinfo.html
   */
  public static readonly USERINFO_ENDPOINT: string =
    WebApiBaseUrl + "/connect/userinfo";

  public static readonly CLIENT_ID: string = "HHK";

  /**
   * Resource Owner Password Credential grant.
   */
  public static readonly GRANT_TYPE: string = "password";

  /**
   * The Web API, refresh token (offline_access) & user info (openid profile roles).
   */
  public static readonly SCOPE: string =
    "WebAPI offline_access openid profile roles";

  public static rehfreshTimerEntry: number = 1800000; //Seconds

  public static rehfreshTimerOverview: number = 60000; //Seconds
}
